import React from "react";
import { Link } from "react-router-dom";
import PageMeta from "./PageMeta";

const NotFound = () => (
  <main className="empty-state-page">
    <PageMeta title="Page not found" />
    <div className="empty-state-card">
      <span className="eyebrow">404</span>
      <h1>This page has gone off the board.</h1>
      <p>Try the shop instead—there is plenty worth tasting.</p>
      <Link className="button button--primary" to="/shop">
        Browse the shop
      </Link>
    </div>
  </main>
);

export default NotFound;
